import { getAssetUrl } from 'lib/config/assetUrls';
import type { FoodSummary, MealTiming } from 'lib/ogdb/types';

export type { FoodSpikeType } from 'lib/ogdb/types';

export const TimeToMealMap: Record<
  MealTiming,
  { title: string; image: string }
> = {
  breakfast: {
    title: 'Breakfast',
    image: getAssetUrl('/web_v2/icons/food-time/Breakfast.svg'),
  },
  lunch: {
    title: 'Lunch',
    image: getAssetUrl('/web_v2/icons/food-time/Lunch.svg'),
  },
  afternoon: {
    title: 'Afternoon Snack',
    image: getAssetUrl('/web_v2/icons/food-time/Afternoon-snack.svg'),
  },
  dinner: {
    title: 'Dinner',
    image: getAssetUrl('/web_v2/icons/food-time/Dinner.svg'),
  },
  midnight: {
    title: 'Midnight Snack',
    image: getAssetUrl('/web_v2/icons/food-time/Midnight.svg'),
  },
};

export const foodHref = (
  food: Pick<FoodSummary, 'url_friendly_name' | 'food_id'>,
) => `/ogdb/${food.url_friendly_name || food.food_id}/`;
